export default Vue => {
  Vue.component("v-calc", () => import("./v-calc.vue"));
};
